import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getResolutionActivityFromSpecificTrainingAction } from "@icarius-pages/myTraining/actions";
import { getResolutionData } from "@icarius-pages/myTraining/selectors";
import { getUserData } from "@icarius-app/selectors";
import { Button } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { ACTIVITY_STATUS_OPTIONS } from "@icarius-pages/myTraining/constants";
import Resolutions from "./resolutions";
import GradeActivityDialog from "./gradeActivityDialog";
import GradesHistoryContent from "./gradesHistoryContent";

const GradesTab = (props) => {
    const { trainingData, activityData } = props;

    const [gradeDialogIsOpen, setGradeDialogIsOpen] = useState(false);

    const dispatch = useDispatch();
    const resolutionData = useSelector(getResolutionData);
    const { code: loggedInUserCode } = useSelector(getUserData);

    const handleOpenGradeActivityDialog = (code) => {
        dispatch(getResolutionActivityFromSpecificTrainingAction(trainingData.id, activityData.id, code)).then(
            (resp) => {
                if (resp.status === 200) {
                    setGradeDialogIsOpen(true);
                }
            }
        );
    };

    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 10,
                }}
            >
                {trainingData.isParticipant && (
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        {activityData.status === ACTIVITY_STATUS_OPTIONS.completed && (
                            <Button
                                fullWidth
                                variant="contained"
                                className="whiteText"
                                onClick={() => handleOpenGradeActivityDialog(loggedInUserCode)}
                            >
                                {getLocalizedString("viewResolution")}
                            </Button>
                        )}
                        <GradesHistoryContent data={activityData.grades} />
                    </div>
                )}
                {!trainingData.isParticipant && (
                    <Resolutions data={activityData.resolutions} handleClick={handleOpenGradeActivityDialog} />
                )}
            </div>
            {gradeDialogIsOpen && (
                <GradeActivityDialog
                    open={gradeDialogIsOpen}
                    readOnly={
                        resolutionData?.passed === true ||
                        (resolutionData?.passed === false &&
                            resolutionData?.currentAttempt < resolutionData?.attempts) ||
                        !trainingData.isInstructor ||
                        trainingData.isFinished
                    }
                    trainingData={trainingData}
                    activityData={activityData}
                    resolution={resolutionData}
                    handleClose={() => setGradeDialogIsOpen(false)}
                />
            )}
        </>
    );
};

export default GradesTab;
